'use strict';

import FieldView from 'views/record/Field';

class FloatField extends FieldView{
}

export default FloatField;
